export default __webpack_public_path__ + "static/media/standsExpo_MT.0130be25.jpg";